/**
 * Componentes visuais compartilhados pelas páginas do módulo Administração :: Grupos.
 *
 * O que também é usado por outros módulos mora em `../lifeshub-common`.
 */
import { styled } from '@mui/material/styles'

/** Célula de tabela com título e descrição empilhados. */
export const CellIdentity = styled('div')({
    minWidth: 0,
    paddingTop: 2,
    paddingBottom: 2
})

export const CellTitle = styled('div')({
    fontWeight: 750,
    marginBottom: 3,
    lineHeight: 1.25,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
})

export const CellDesc = styled('div')({
    color: 'var(--muted)',
    fontSize: 12,
    lineHeight: 1.25,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
})
